module.exports = __webpack_public_path__ + "img/37.ea2de24c.jpg";